import 'ui-core/components/coolbar/js/coolbar';
const coolbar = UX.coolbar;
coolbar.holder = $('.coolBar--sections .article-sections');
coolbar.topbar = $('.article-top-section .coolBar__drop');
const init = coolbar.init;
coolbar.init = function () {
    init();
    const height = coolbar.get.headerHeight();
    if (height) {
        $('.coolBar--res').css('top', height);
    }
    coolbar.fill_top.sections();
};
coolbar.fill_top = {
    sections: function () {
        var top_sections;
        if ($('.article-top-section').length && coolbar.sections.length > 1) {
            top_sections = $('<ul class="rlist w-slide--list"/>').appendTo(coolbar.topbar);
            coolbar.sections.each(function () {
                var $this = $(this);
                var li_top = $('<li/>').attr('role', 'menuitem').appendTo(top_sections);
                var link = $('<a class="w-slide__hide"/>')
                    .attr('href', '#' + $this.attr('id'))
                    .appendTo(li_top);
                /*eslint-disable*/
                var spaner = $('<span/>').text($(this).text()).appendTo(link);
                /*eslint-enable*/
            });
        } else {
            $('.article-top-section').remove();
        }
    },
};

coolbar.get.headerHeight = () => {
    const $header = $('.header');
    if (!coolbar.isMobile) {
        return;
    }
    let height = $header.outerHeight() || 0;
    if ($(this).scrollTop() > 0) {
        height = $header.find('.locked').outerHeight();
    } else {
        height = coolbar.headerHeight;
    }
    return height;
};

coolbar.addtionalControls = () => {
    $(window).on('scroll', () => {
        const height = coolbar.get.headerHeight();
        if (!height) {
            return;
        }
        $('.coolBar--res').css('top', height);
    });
};
